import React, { useState, useEffect } from 'react'
import { useSupplierFormContext } from '../hook/supplier-form'
import { CKEditor } from '@ckeditor/ckeditor5-react'
import { 
  ClassicEditor,
  Bold,
  Essentials,
  Italic,
  Mention,
  Paragraph,
  Undo,
  Font,
  FontSize,
  Heading,
  List,
  Alignment,
  Link,
  PasteFromOffice
} from 'ckeditor5'
import { Paper, Text } from '@mantine/core'

const FormBiographySupplier = () => {
  const form = useSupplierFormContext()
  const [isLoaded, setIsLoaded] = useState(false)

  const configBiography = {
    plugins:[
      Bold,
      Essentials,
      Italic,
      Mention,
      Paragraph,
      Undo,
      Font,
      FontSize,
      Heading,
      List,
      Alignment,
      Link,
      PasteFromOffice
    ],
    alignment: {
      options: [ 'left', 'right' ]
    },
    fontSize: {
      options: [
          9,
          10,
          11,
          12,
          13,
          14,
          15,
          16,
          17,
          18,
          19,
          20,
          21,
          22
      ],
      supportAllValues: true
    },
    list: {
      properties: {
        styles: true,
        startIndex: true,
        reversed: true
      }
    },
    link: {
      decorators: {
        addTargetToExternalLinks: {
          mode: 'automatic',
          callback: url => /^(https?:)?\/\//.test( url ),
          attributes: {
              target: '_blank',
              rel: 'noopener noreferrer'
          }
        }
      }
    },
    toolbar: {
      items: [
        'undo', 'redo',
        '|',
        'heading',
        '|',
        'fontSize', 'Bold', 'Italic', 'alignment',
        '|',
        'link',
        '|',
        'bulletedList', 'numberedList',
        '|',
      ],
      shouldNotGroupWhenFull: true
    },
    initialData: `${form.getValues().biography}`
  }

  useEffect(() => {
    setIsLoaded(true)
  }, [])

  const initCKeditorBiography = () => {
    return (
      <CKEditor
        editor={ClassicEditor}
        config={configBiography}
        data={form.getValues().biography}
        onReady={(editor) => {
          editor.execute('fontSize', { value: '12px' })
          editor.editing.view.change((writer) => {
            writer.setStyle(
              'height',
              '250px',
              editor.editing.view.document.getRoot()
            )
          })
        }}
        onChange={( event, editor ) => {
          editor.execute('fontSize', { value: '12px' })
          const valueEditor = editor.getData()
          form.setFieldValue('biography', valueEditor)
        }}
      />
    )
  }

  return (
    <Paper shadow="xs" radius="md" withBorder p="sm" mb='md'>
      <Text fz={14} fw='bold' mb='sm'>Supplier Biography</Text>
      {isLoaded ? initCKeditorBiography() : ''}
    </Paper>
  )
}

export default FormBiographySupplier